<!-- Width-limiting container -->
<div
  class="max-w-8xl @container/header relative mx-auto"
  [class]="{
    'p-4': padded(),
    'md:p-6': padded(),
  }"
>
  <!-- Page header goes here -->
  <ng-content></ng-content>
</div>
